var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconComplite = function SvgIconComplite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.472,
    d: "M1.1 9.51a5.54 5.54 0 0 1 2.975-4.912L8.43 2.32a5.54 5.54 0 0 1 5.138 0l4.356 2.278A5.54 5.54 0 0 1 20.9 9.51v6.209c0 4.706-5.528 7.575-8.322 8.724a4.13 4.13 0 0 1-3.156 0C6.628 23.293 1.1 20.425 1.1 15.719z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.472,
    d: "m15.95 10.996-5.85 5.21-3.15-2.805"
  })));
};
export default SvgIconComplite;